import React, { Component } from 'react';
import { connect } from 'react-redux';
import CurrencyTypeView from '../../../../../itrust_common/components/others/CurrencyTypeView';
import EyeglassLenses from './EyeglassLenses';

class Eyeglass extends Component {

  renderFrameDetails(frame) {
    return <>
      {frame &&
        <>
          {frame.brand} <br />
          <b>{`${(frame.model && frame.color) ? "Model Name-" : frame.model ? 'Model Name' : ''}${frame.color ? "Color" : ''}:`}</b><br />
          {frame.model}{(frame.model && frame.color) ? `-${frame.color}` : frame.color}<br />
          <b>{`${((frame.eye_size && frame.bridge) || (frame.eye_size && frame.temple)) ? "Eye Size-" : frame.eye_size ? 'Eye Size' : ''}${(frame.bridge && frame.temple) ? "Bridge-" : frame.bridge ? 'Bridge' : ""}${frame.temple ? "Temple" : ""}:`}</b><br />
          {frame.eye_size}{(frame.eye_size && frame.bridge) ? `-${frame.bridge}` : frame.bridge}{((frame.bridge || frame.eye_size) && frame.temple) ? `-${frame.temple}` : frame.temple}<br />
        </>
      }
    </>
  }

  render() {
    const { eyeglasses } = this.props
    return (
      eyeglasses.map((glass, index) => [
        <tr className="text-dark bg-light border-bottom border-white border-bottom-2">
          <td><h6>Eyeglass Order #{index + 1}</h6></td>
          <td colspan="5"><h6>Details</h6></td>
          <td><h6 className="text-danger">{glass.overall_cash_discount && <CurrencyTypeView amount={glass.overall_cash_discount} />}</h6></td>
          <td><h6>{glass.total ? <CurrencyTypeView amount={glass.total} /> : ''}</h6></td>
        </tr>,
        <tr className="text-dark bg-light border-bottom border-white border-bottom-2">
          <td>Frame</td>
          <td>{this.renderFrameDetails(glass.frame_details)}</td>
          <td className="pl-8">{glass.frame_unit_price ? <CurrencyTypeView amount={glass.frame_unit_price} /> : ''}</td>
          <td>{glass.frame_copay ? <CurrencyTypeView amount={glass.frame_copay} /> : ''}</td>
          <td>{(glass.frame_cash_discount || glass.frame_percentage_discount) ? <CurrencyTypeView amount={glass.frame_discount_type === "cash" ? glass.frame_cash_discount : glass.frame_percentage_discount} /> : ''}</td>
          <td colSpan="3">Not A</td>
        </tr>,
        <EyeglassLenses glass={glass} />,
        <tr className="text-dark bg-light border-bottom border-white border-bottom-2">
          <td>Material</td>
          <td>{glass.lens_material_name}</td>
          <td className="pl-8">{glass.lens_material_unit_price ? <CurrencyTypeView amount={glass.lens_material_unit_price} /> : ''}</td>
          <td>{glass.lens_material_copay ? <CurrencyTypeView amount={glass.lens_material_copay} /> : ''}</td>
          <td>{(glass.lens_material_cash_discount || glass.lens_material_percentage_discount) ? <CurrencyTypeView amount={glass.lens_material_discount_type === "cash" ? glass.lens_material_cash_discount : glass.lens_material_percentage_discount} /> : ''}</td>
          <td colSpan="3">{glass.lens_material_subtotal ? <CurrencyTypeView amount={glass.lens_material_subtotal} /> : ''}</td>
        </tr>,
        glass.eyeglass_addons_attributes && glass.eyeglass_addons_attributes.map((addon, index) => (
          <tr className="text-dark bg-light border-bottom border-white border-bottom-2">
            <td>Add-ons #{index + 1}</td>
            <td>{addon.addon_name}</td>
            <td className="pl-8">{addon.unit_price ? <CurrencyTypeView amount={addon.unit_price} /> : ''}</td>
            <td>{addon.copay ? <CurrencyTypeView amount={addon.copay} /> : ''}</td>
            <td>{(addon.cash_discount || addon.percentage_discount) ? <CurrencyTypeView amount={addon.discount_type === "cash" ? addon.cash_discount : addon.percentage_discount} /> : ''}</td>
            <td colSpan="3">{addon.subtotal ? <CurrencyTypeView amount={addon.subtotal} /> : ''}</td>
          </tr>
        )),
        <tr className="text-dark bg-light border-bottom border-white border-bottom-2">
          <td colSpan="3">Material Copay</td>
          <td colSpan="2">{glass.material_copay ? <CurrencyTypeView amount={glass.material_copay} /> : ''}</td>
          <td colSpan="3">{glass.material_copay ? <CurrencyTypeView amount={glass.material_copay} /> : ''}</td>
        </tr>,
        <tr className="text-dark bg-light border-bottom border-white border-bottom-2">
          <td colSpan="3">Frame Allowance</td>
          <td colSpan="2">{glass.frame_allowance ? <CurrencyTypeView amount={glass.frame_allowance} /> : ''}</td>
          <td colSpan="3">{glass.frame_allowance ? <CurrencyTypeView amount={glass.frame_allowance} /> : ''}</td>
        </tr>,
        <tr className="text-dark bg-light border-bottom border-white border-bottom-2">
          <td colSpan="3">Frame Only Discount</td>
          <td colSpan="2">{glass.frame_only_percentage_discount ? <CurrencyTypeView amount={glass.frame_only_percentage_discount} /> : ''}</td>
          <td colSpan="3">{glass.frame_only_percentage_discount ? <CurrencyTypeView amount={glass.frame_only_percentage_discount} /> : ''}</td>
        </tr>
      ])
    )
  }
}

export default connect()(Eyeglass);